import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DocsList = _resolveComponent("DocsList")

  return (_openBlock(), _createBlock(_component_DocsList, {
    class: "documents",
    api_url: $options.api_url,
    format_filter: $options.formatFilter
  }, null, 8 /* PROPS */, ["api_url", "format_filter"]))
}